export const AMBIENTEST_TEXT = {
    LOGBOOK: {
        LABELS:{
            DATA_TYPE: 'Tipo de consulta*',
            SEARCH_CURP: 'Curp*',
            SEARCH_USER: 'Usuario*',
            LOGBOOK_SEARCH: 'Búsqueda (3 letras min)',
        },
        TABLE: {
            ID: 'Id',
            CURP: 'Curp',
            TYPE: 'Tipo',
            USERNAME: 'Responsable',
            STATUS: 'Estatus',
            DATE: 'Fecha'
        },
        BUTTONS: {
            CLEAN: 'Limpiar',
            SEARCH: 'Buscar',
            CASE_SENSITIVE: 'Case Sensitive'
        },
    }
}